'use client';

import { useEffect } from 'react';

// Filters out noise that isn't actionable
const IGNORE = [
  'ResizeObserver loop',
  'Non-Error promise rejection',
  'favicon',
  'extension',
  'chrome-extension',
  'Script error',
  '__webpack',
];

function shouldIgnore(msg: string) {
  return IGNORE.some((p) => msg.includes(p));
}

function report(type: string, message: string, url: string, stack: string) {
  if (shouldIgnore(message)) return;
  fetch('/api/errors', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ type, message, url, stack }),
    keepalive: true,
  }).catch(() => {});
}

export default function ErrorMonitor() {
  useEffect(() => {
    const onError = (event: ErrorEvent) => {
      report(
        'error',
        event.message,
        event.filename ?? window.location.href,
        event.error?.stack ?? ''
      );
    };

    const onRejection = (event: PromiseRejectionEvent) => {
      const msg = event.reason instanceof Error ? event.reason.message : String(event.reason);
      const stack = event.reason instanceof Error ? (event.reason.stack ?? '') : '';
      report('unhandledrejection', msg, window.location.href, stack);
    };

    window.addEventListener('error', onError);
    window.addEventListener('unhandledrejection', onRejection);
    return () => {
      window.removeEventListener('error', onError);
      window.removeEventListener('unhandledrejection', onRejection);
    };
  }, []);

  return null;
}
